// Single source of truth for the seven roles a user can identify with.
// Alphabetised by display label — the order the UI shows the choices in.
// Keep keys in sync with USER_TYPES in /app/backend/models.py.
export const USER_TYPE_OPTIONS = [
  { key: "breeder",    label: "Breeder",    blurb: "I breed dogs and raise litters" },
  { key: "groomer",    label: "Groomer",    blurb: "I groom dogs professionally" },
  { key: "handler",    label: "Handler",    blurb: "I show dogs in conformation" },
  { key: "pet_parent", label: "Pet Parent", blurb: "I share my life with one or more dogs" },
  { key: "puppy",      label: "Puppy",      blurb: "I'm raising a puppy" },
  { key: "senior_dog", label: "Senior Dog", blurb: "I'm caring for a senior" },
  { key: "sports",     label: "Sports",     blurb: "Agility, dock, lure, herding, etc." },
];

export const USER_TYPE_KEYS = USER_TYPE_OPTIONS.map((o) => o.key);

// "breeder" → "Breeder", "senior_dog" → "Senior Dog" — used in summaries.
export const userTypeLabel = (key) =>
  (USER_TYPE_OPTIONS.find((o) => o.key === key) || {}).label || key;
